import { render, staticRenderFns } from "./CompMultipleChoice.vue?vue&type=template&id=bb905252&"
import script from "./CompMultipleChoice.vue?vue&type=script&lang=ts&"
export * from "./CompMultipleChoice.vue?vue&type=script&lang=ts&"
import style0 from "./CompMultipleChoice.vue?vue&type=style&index=0&id=bb905252&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports